import dayjs from "dayjs"
import { setEndType, setRepeatUnits, setIsRecurring, setOccurrences, setRepeatCount, setDateRange } from "./recurringWorkareaModel"
import { RecurringSchedule, RecurrenceUnit, RecurrenceEndType } from "../../../../domain/recurringSchedule"

export type Action =
  | { type: 'IS_RECURRING_CHANGED', value: boolean }
  | { type: 'REPEAT_COUNT_CHANGED', value: number }
  | { type: 'REPEAT_UNITS_CHANGED', value: RecurrenceUnit }
  | { type: 'END_TYPE_CHANGED', value: RecurrenceEndType }
  | { type: 'OCCURRENCES_CHANGED', value: number }
  | { type: 'DATE_RANGE_CHANGED', value: [dayjs.Dayjs, dayjs.Dayjs] }
  | { type: 'RESET', value: RecurringSchedule }

export type State = RecurringSchedule & { hasChanges: boolean }

const markChanged = (state: RecurringSchedule): State => ({ ...state, hasChanges: true })
const markUnchanged = (state: RecurringSchedule): State => ({ ...state, hasChanges: false })

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'IS_RECURRING_CHANGED':
      return markChanged(setIsRecurring(state, action.value))
    case 'REPEAT_COUNT_CHANGED':
      return markChanged(setRepeatCount(state, action.value))
    case 'REPEAT_UNITS_CHANGED':
      return markChanged(setRepeatUnits(state, action.value))
    case 'END_TYPE_CHANGED':
      return markChanged(setEndType(state, action.value))
    case 'OCCURRENCES_CHANGED':
      return markChanged(setOccurrences(state, action.value))
    case 'DATE_RANGE_CHANGED':
      return markChanged(setDateRange(state, dayjs(action.value?.[0]), dayjs(action.value?.[1])))
    case 'RESET':
      return markUnchanged(action.value)
    default:
      return state
  }
}
